import { create } from 'zustand'
import { persist } from 'zustand/middleware'
import type { UserSession } from '@/types'

/**
 * Store de sesión del frontend MapeoData (Zustand + persistencia
 * localStorage).
 *
 * Mantiene el JWT del usuario logueado vía GoTrue MapeoData (DEC-003).
 * Lo lee `src/lib/api.ts` para inyectar `Authorization: Bearer ${token}`
 * en todas las llamadas a `/api/v1/*` (DEC-010).
 *
 * persist() guarda la sesión en localStorage para sobrevivir a refresh.
 * El refresh_token permite renovar el access_token sin re-login (manejado
 * automáticamente por @supabase/supabase-js si llamas a supabase.auth.*).
 */

interface SessionStore {
  session: UserSession | null
  setSession: (session: UserSession | null) => void
  clearSession: () => void
}

export const useSession = create<SessionStore>()(
  persist(
    (set) => ({
      session: null,
      setSession: (session) => set({ session }),
      clearSession: () => set({ session: null }),
    }),
    {
      name: 'mapeodata-session',
    },
  ),
)

/**
 * Helper para obtener el token actual sin suscribir al componente al
 * store. Útil desde `src/lib/api.ts` (no es un componente React).
 */
export function getAccessToken(): string | null {
  return useSession.getState().session?.access_token ?? null
}
